import {
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap"
import { Link } from 'react-router-dom';
import NoData from '../../../../components/NoData/NoData';
import MainService from '../../../../Services/MainService';


const TotalOrder = ({
  transactionOverview,
  transactionDetails,
  isInstantPaymentPage = false,
}) => {

  return (
    <>
      <Card>
        {
          transactionOverview ?
            <CardBody>
              <Row>
                <Col xs="12">
                  <div>
                    {
                      transactionOverview.fiatAmountFormated ?
                        <div className='d-flex justify-content-between align-items-center'>
                          <h5 className="mb-0 card-title">Total Order</h5> <b className='fs-5'>{transactionOverview.fiatAmountFormated || 0} USD</b>
                        </div>
                        : null
                    }
                  </div>
                  <hr />
                </Col>
                <Col xl="12">
                  <div>
                    <div className='d-flex justify-content-between'>
                      <p className="text-muted font-size-14 text-truncate mb-2">
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                        Transaction status:
                      </p>
                      <div>
                        {
                          transactionOverview.transactionStatus && transactionOverview.transactionStatus.toLowerCase() === "confirmed" ?
                            <span className="ms-2 font-size-12 badge-soft-success badge badge-secondary badge-pill">{transactionOverview.transactionStatus}</span>
                            : <span className="font-size-12 badge-soft-info badge badge-secondary badge-pill">{transactionOverview.transactionStatus}</span>
                        }
                      </div>
                    </div>
                    <div className='d-flex justify-content-between'>
                      <p className="text-muted font-size-14 text-truncate mb-2">
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                        Fiat payout status:
                      </p>
                      <div>
                        {
                          transactionOverview.fiatPayoutStatus && transactionOverview.fiatPayoutStatus.toLowerCase() === "completed" ?
                            <span className="ms-2 font-size-12 badge-soft-success badge badge-secondary badge-pill">{transactionOverview.fiatPayoutStatus}</span>
                            : <span className="font-size-12 badge-soft-warning badge badge-secondary badge-pill">{transactionOverview.fiatPayoutStatus}</span>
                        }
                      </div>
                    </div>
                    {
                      transactionDetails && transactionDetails.instantPayment ? null :
                        transactionOverview.bankAccount ?
                          <div>
                            <div className='d-flex justify-content-between'>
                              <p className="text-muted font-size-14 text-truncate mb-2">
                                <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                Merchant bank ID:
                              </p>
                              <div>
                                <span className="ms-2 font-size-12 badge-soft-primary badge badge-secondary badge-pill">{transactionOverview.bankAccount}</span>
                              </div>
                            </div>
                          </div>
                          : null
                    }
                    <hr />
                    <div className='d-flex justify-content-between flex-wrap'>
                      <p className="text-muted font-size-14 text-truncate mb-2">
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                        Payment Type:
                      </p>
                      <div>
                        <b>{isInstantPaymentPage ? "Instant Payment" : "Standard"}</b>
                      </div>
                    </div>
                    <div className='d-flex justify-content-between'>
                      <p className="text-muted font-size-14 text-truncate mb-2">
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                        Creation:
                      </p>
                      <div>
                        <span>{MainService.convertUTCToLocal(transactionDetails?.createDate, "ll HH:mm:ss")}</span>
                      </div>
                    </div>

                    {
                      transactionDetails && transactionDetails.instantPayment ?
                        <>
                          <div className='d-flex justify-content-between'>
                            <p className="text-muted font-size-14 text-truncate mb-2">
                              <i className="mdi mdi-chevron-right text-primary me-1"></i>
                              Expiration:
                            </p>
                            <div>
                              <span>{MainService.convertUTCToLocal(transactionDetails.instantPayment.expireDate, "ll HH:mm:ss")}</span>
                            </div>
                          </div>


                          {/* <div className='d-flex justify-content-between flex-wrap'>
                            <p className="text-muted font-size-14 text-truncate mb-2">
                              <i className="mdi mdi-chevron-right text-primary me-1"></i>
                              Paying Customer Full Name:
                            </p>
                            <div>
                              <span>{transactionDetails.instantPayment?.customerFullName}</span>
                            </div>
                          </div>
                          <div className='d-flex justify-content-between flex-wrap'>
                            <p className="text-muted font-size-14 text-truncate mb-2">
                              <i className="mdi mdi-chevron-right text-primary me-1"></i>
                              Paying Customer Email Address:
                            </p>
                            <div>
                              <span>{transactionDetails.instantPayment?.customerEmail}</span>
                            </div>
                          </div> */}
                        </>
                        : null
                    }
                    {
                      transactionDetails?.transactionText ?
                        <div className='d-flex justify-content-between flex-wrap'>
                          <p className="text-muted font-size-14 text-truncate mb-2">
                            <i className="mdi mdi-chevron-right text-primary me-1"></i>
                            Transaction Text:
                          </p>
                          <div>
                            <p style={{ wordBreak: "break-word" }}>{transactionDetails.transactionText}</p>
                          </div>
                        </div>
                        : null
                    }
                    {
                      transactionDetails?.cryptoTransactionHash ?
                        <div className='d-flex justify-content-between flex-wrap'>
                          <p className="text-muted font-size-14 text-truncate mb-2">
                            <i className="mdi mdi-chevron-right text-primary me-1"></i>
                            Transaction Hash:
                          </p>
                          <div>
                            <p style={{ wordBreak: "break-word" }}>{transactionDetails.cryptoTransactionHash}</p>
                          </div>
                        </div>
                        : null
                    }
                  </div>
                </Col>

              </Row>
              {/* <Col>
                <div className="media">
                  <div className="me-3">
                    <h5 className="font-size-14"><i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle bx-fade-right"></i></h5>
                  </div>
                  <div className="media-body">
                    <Link to="#" className='text-underline'>View Block Explorer for Transaction ???</Link>
                  </div>
                </div>
              </Col> */}
            </CardBody>
            : <NoData width={150} />
        }

      </Card>
    </>
  )
}

export default TotalOrder